import { FabricHexagon } from "./Shapes/FabricHexagon";

/**
 * @description - ForLoopPlugin used in SmartContractDesigner
 */
export class ForLoopPlugin extends FabricHexagon {
    fillStyle = "#256BDE";

    name = "For";

    constructor(options, ctx, data) {
        super(options, ctx, data);
        this.points = { start: 2, end: 2, initial: 4 };
    }

    /**
         * @description Draws the plugin
         */
    draw() {
        const size = super.getSize();
        const position = super.getPosition();
        const styles = { fillStyle: this.fillStyle };
        this.drawHexagon(position.x + (size.width / 2), position.y + (size.height / 2), size.width / 2, styles, this.ctx);
        this.fabricPluginRedrawed();
    }

    /**
     * @description Updates the plugin
     * @param options - {size,position}
     */
    update(options) {
        this.setPosition(options && options.position ? options.position : super.getPosition());
        this.setSize(options && options.size ? options.size : super.getSize());
    }
}
